import { render } from "./_team.vue?vue&type=template&id=3d041a40&scoped=true&lang=pug"
import script from "./_team.vue?vue&type=script&lang=js"
export * from "./_team.vue?vue&type=script&lang=js"

import "./_team.vue?vue&type=style&index=0&id=3d041a40&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d041a40"]])

export default __exports__